const moduleTabs = document.querySelectorAll(".module-tabs");

moduleTabs.forEach((module) => {
  const tabs = module.querySelectorAll(".module-tabs__li");
  const contentItems = module.querySelectorAll(".module-tabs__content-item");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const index = tab.getAttribute("data-index");

      tabs.forEach((t) => t.classList.remove("isActive"));
      contentItems.forEach((c) => c.classList.remove("isActive"));

      tab.classList.add("isActive");
      const content = module.querySelector(
        `.module-tabs__content-item[data-index="${index}"]`
      );
      if (content) {
        content.classList.add("isActive");
      }
    });
  });
});
